type FlodeskPayload = {
  firstname?: string;
  lastname?: string;
  email: string;
  phone?: string;
  segmentId: string;
  onSuccess?: () => void;
  onError?: (error: any) => void;
};

export async function submitToFlodesk({
  firstname,
  lastname,
  email,
  phone,
  segmentId,
  onSuccess,
  onError,
}: FlodeskPayload) {
  const apiKey = process.env.REACT_APP_FLODESK_ENCODE_BASE64_KEY;
  if (!apiKey) {
    const err = new Error("Missing Flodesk API key");
    onError?.(err);
    return;
  }

  try {
    // Step 1: Create or update subscriber
    const subscriberResponse = await fetch(
      "https://api.flodesk.com/v1/subscribers",
      {
        method: "POST",
        headers: {
          "User-Agent": "Caring Blocks (www.caringblocks.com)",
          Authorization: `Basic ${apiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          first_name: firstname,
          last_name: lastname,
          email,
          status: "active",
          custom_fields: {
            full_name: `${firstname} ${lastname}`,
            phone_number: phone,
            whats_app_number: phone,
          },
        }),
      }
    );

    if (!subscriberResponse.ok) {
      const errorData = await subscriberResponse.json();
      throw new Error(
        `Failed to create subscriber: ${JSON.stringify(errorData)}`
      );
    }

    const subscriberData = await subscriberResponse.json();
    const subscriberId = subscriberData.id; // ✅ use the Flodesk subscriber ID

    // Step 2: Add subscriber to segment (using subscriberId, not email)
    const segmentResponse = await fetch(
      `https://api.flodesk.com/v1/subscribers/${subscriberId}/segments`,
      {
        method: "POST",
        headers: {
          "User-Agent": "Caring Blocks (www.caringblocks.com)",
          Authorization: `Basic ${apiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          segment_ids: [segmentId],
        }),
      }
    );

    if (!segmentResponse.ok) {
      const errorData = await segmentResponse.json();
      throw new Error(
        `Failed to add to segment: ${JSON.stringify(errorData)}`
      );
    }

    // ✅ success
    onSuccess?.();
  } catch (error) {
    console.error("Flodesk submission failed:", error);
    onError?.(error);
  }
}
